"use strict";

export class Audio {
    static muted = false;

    static setMute(mute) {
        if (mute) {
            PIXI.sound.muteAll();
        } else {
            PIXI.sound.unmuteAll();
        }

        Audio.muted = mute;
    }

    static setGlobalVolume(volume) {
        PIXI.sound.volumeAll = volume;
    }
}